// eslint-disable-next-line
import React, { FC } from 'react';
import Grid from '@material-ui/core/Grid';

const WizardStepContainer: FC = ({ children }) => (
  <Grid
    container
    direction="column"
    style={{ minHeight: '80vh', height: '100%', position: 'relative' }}
  >
    {children}
  </Grid>
);

export default WizardStepContainer;
